export { default } from "ember-moment/helpers/now";
